<template>
	<div>
		<el-dialog
			title="添加辅助核算"
			:visible.sync="isShow"
			:close-on-click-modal="false"
			width='380px' class='default-dialog'>
			<el-form
				ref="form"
				:model="form"
				v-loading="loading"
				element-loading-text="正在保存中，请稍等..."
				label-width="70px">
				<el-form-item label="科目：">
					<span v-text="subjectName"></span>
				</el-form-item>
				<template v-if="options.auxiliary.length" v-for="(item, index) in options.auxiliary">
					<el-form-item :label="`${item.name}：`">
						<el-select
							size="mini"
							filterable
							v-model="ids[`id_${index}`]"
							filterable
							@change="handleChange($event, index)" placeholder="请选择(必填)">
							<el-option
								v-for="option in item.auxiliaryAccContentVos"
								:key="option.id"
								:label="`${option.code} - ${option.name}`"
								:value="option.id">
							</el-option>
						</el-select>
					</el-form-item>
				</template>
			</el-form>
			<span slot="footer" class="dialog-footer" v-if="!loading">
		    	<el-button size="small" type='warning' @click="isShow = false">取 消</el-button>
			    <el-button size="small" class='minButton' @click="requset" :disabled="isDisabled">确 定</el-button>
		  	</span>
		</el-dialog>
	</div>
</template>

<script>

export default {
	props: {
		subjectId: String,
		showVisible: Boolean,
		rowIndex: [Number, String]
	},
	data () {
		return {
			form: {
				subjectId: '',				// 科目id
				auxiliaryAccContentIds: []	// 辅助核算id集合
			},
			options: {
				auxiliary: []				// 辅助核算
			},
			ids: {},						// 记录辅助核算选中后的数据
			subjectName: '',				// 科目名(编码+名称)
			loading: false,					// Loading加载动画
			isDisabled: false,				// 是否禁用提交按钮
		}
	},
	computed: {
		isShow: {
			get () {
				return this.showVisible;
			},
			set (val) {
				this.$emit('update:showVisible', val);
			}
		}
	},
	methods: {
		// 根据subjectId获取辅助核算
		getAuxiliaryData () {
			let params = { subjectId: this.subjectId }
			this.$http.post('auxiliaryAccounting/getAuxiliaryBySubjectId' , params).then(res=>{
				if(res && res.data.code == 1) {
					this.subjectName = `${res.data.data.subjectCode}-${res.data.data.subjectName}`
					this.form.subjectId = res.data.data.subjectId;
					this.options.auxiliary = res.data.data.auxiliarys;
					if(res.data.data.auxiliarys.length) {
						res.data.data.auxiliarys.forEach((item, index) => {
					 		this.$set(this.ids, `id_${index}`, '');
					 	})
					}
				}
			})
		},
		// 选择辅助核算
		handleChange (val, index) {
			this.form.auxiliaryAccContentIds = [];
			this.$set(this.ids, `id_${index}`, val);
			for (let k in this.ids) {
				this.form.auxiliaryAccContentIds.push(this.ids[k]);
			}
		},
		// 保存请求
		async requset () {
			if (this.options.auxiliary.length !== this.form.auxiliaryAccContentIds.length) {
				return this.$message.error('您当前还有辅助核算未选择，请全部选择完毕后再提交！')
			}

			this.loading = true;
			this.isDisabled = true;
			try {
				this.$http.post('subjectAuxiliary/add', this.form).then(res=>{
					if(res && res.data.code == 1) {
						this.$emit('handleCallback', {
								value: res.data.data,
								type: 'add',
								rowIndex: this.rowIndex
							});
						this.isShow = false;
						this.$message.success('添加成功！');
					}
				})
			} finally {
				this.loading = false;
				this.isDisabled = false;
			}
		},
	},
	created () {
		//this.debounceRequset = this._.debounce(this.requset, 500);
	},
	watch: {
		showVisible (val) {
			if (val) {
				Object.assign(this.$data, this.$options.data())
				this.getAuxiliaryData();
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialog/addAuxiliaryAccContent.vue